import type { ReactNode } from 'react';
import type { QuizAnswers } from '../types';
import { HorseRace } from './HorseRace';

interface Props {
  step: number;
  totalSteps: number;
  answers: QuizAnswers;
  heading: string;
  subtitle: string;
  onBack?: () => void;
  onNext: () => void;
  nextDisabled: boolean;
  nextLabel?: string;
  nextPrimary?: boolean;
  children: ReactNode;
}

export function QuizShell({
  step,
  totalSteps,
  answers,
  heading,
  subtitle,
  onBack,
  onNext,
  nextDisabled,
  nextLabel,
  nextPrimary,
  children,
}: Props) {
  return (
    <section className="fb-step fb-quiz" aria-labelledby="fb-quiz-heading">
      <header className="fb-quiz__header">
        <HorseRace answers={answers} step={step} totalSteps={totalSteps} />
      </header>
      <div className="fb-quiz__body">
        <h2 id="fb-quiz-heading" className="fb-quiz__heading">
          {heading}
        </h2>
        <p className="fb-quiz__subtitle">{subtitle}</p>
        {children}
      </div>
      <footer className="fb-quiz__footer">
        {onBack && (
          <button type="button" className="fb-quiz__back" onClick={onBack}>
            Back
          </button>
        )}
        <button
          type="button"
          className={'fb-quiz__next' + (nextPrimary ? ' fb-quiz__next--primary' : '')}
          onClick={onNext}
          disabled={nextDisabled}
        >
          {nextLabel ?? 'Continue'}
        </button>
      </footer>
    </section>
  );
}
